import { CommentaryRepository } from '@/domain/repositories/commentary/CommentaryRepository'
import { Commentary } from '@/domain/value_objects/commentary/Commentary'

export class GetCommentaryUseCase {
  constructor(private commentaryRepository: CommentaryRepository) {}

  async getCommentary(
    displayLanguage: string,
    problemId: string,
    pattern: string,
    type: string,
    filter: string
  ): Promise<Commentary> {
    try {
      const res = await this.commentaryRepository.getCommentary(displayLanguage, problemId, pattern, type, filter)
      return res
    } catch (error) {
      console.error(`Error in GetCommentaryUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
